export const thunkTypes = {
  LIST_COVERAGE: `zones/listCoverage`,
  UPDATE_ZONE: `zones/updateZone`,
  ADD_ZONE: `zones/addZone`,
};
